<template>
  <div class="work-order-page">
    <matrix-statistics span="8" :list="infoCardData(cardData)"></matrix-statistics>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :before-open="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button v-if="row.infoStatus != 1" type="text" size="small" @click="beforeOpen(null,'editArchive',row)">处理</el-button>
      </template>
    </avue-crud>
    <!-- 新增 -->
    <dialog-reset height="60vh" top="2vh" width="50%" :title="visibleTitle" :visible.sync="formVisible">
      <AddFormComponent ref="formComponen" :transmitData="transmitData" @handleClose="handleClose($event,'formVisible')" />
    </dialog-reset>
    <!-- <dialog-reset height="60vh" top="2vh" width="50%" title="处理事故" :visible.sync="formArchiveVisible">
      <ArchiveFormComponent ref="formComponen" :transmitData="transmitData" @handleClose="handleClose($event,'formArchiveVisible')" />
    </dialog-reset> -->
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, uploadEndpoint, exportExcel } from "./api";
import { downloadXls } from "@/util/util";
import { searchTimeConfig } from "@/basic-common/util/common";
import AddFormComponent from "./components/add-form-component.vue";
import ArchiveFormComponent from "./components/archive-form-component.vue";


export default {
  name: "WorkOrderManagement",
  components: {
    AddFormComponent,
    ArchiveFormComponent
  },
  mixins: [crudMixins],
  computed: {
    infoCardData () {
      return function (info) {
        return [{
          label: '待整改',
          value: 123,
          unit: ' 条',
        }, {
          label: '整改中',
          value: 22,
          unit: ' 条',
        }]
      }
    }
  },
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      formVisible: false,
      formArchiveVisible: false,
      exportLoading: false,
      visibleTitle: '新增',
      option: {
        ...this.$store.state.publicOption,
        addBtn: true,
        editBtn: false,
        delBtn: true,
        viewBtn: true,
        menu: true,
        dialogWidth: '800px',
        dialogHeight: '70vh',
        editBtnText: '处理',
        column: [
          {
            label: "事故编号",
            prop: "accidentNumber",
            search: true,
            overHidden: true,
            width: 180,
          },
          {
            label: "发生时间",
            prop: "accidentTime",
            overHidden: true,
            width: 180,
          },
          {
            label: "事故类型",
            prop: "accidentType",
            search: true,
            overHidden: true,
            dicData: this.$store.getters.commonDict['accident_type'],
            dataType: 'string',
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "伤亡情况",
            prop: "casualtyDescription",
            overHidden: true,
          },
          {
            label: "直接原因",
            prop: "directCause",
            overHidden: true,
          },
          {
            label: "上报部门",
            prop: "responsibleDepartmentId",
            overHidden: true,
            multiple: true,
            dataType: 'string',
            type: 'tree',
            dicUrl: "/api/produce/blade-dept/select/deptSelect",
            props: {
              label: "deptName",
              value: "id"
            },
          },
          {
            label: "处理状态",
            prop: "infoStatus",
            overHidden: true,
            search: true,
            dicData: this.$store.getters.commonDict['info_status'],
            dataType: 'string',
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "事故地点",
            prop: "accidentLocation",
            overHidden: true,
            maxlength: 200
          },
          {
            label: "报告人",
            prop: "reporterName",
            type: "input",
            overHidden: true,
          },
          //   {
          //     ...searchTimeConfig,
          //     paramsKey: ["startTime", "endTime"],
          //     span: 24,
          //   },
        ],
      },
    };
  },
  methods: {
    beforeOpen (done, type, row) {
      // 1.传递交互参数 type id  操作api
      this.transmitData = {
        type,
        id: this.form.id || null,
      }

      if (type == 'add') {
        this.visibleTitle = '新增事故'
      } else if (type == 'edit') {
        this.visibleTitle = '归档事故'
      } else {
        this.visibleTitle = '详情'
      }
      if (type == 'editArchive') {
        this.visibleTitle = '归档事故'
        this.transmitData = {
          type: 'edit',
          id: row.id || null,
        }
        this.formVisible = true
      } else {
        this.formVisible = true
      }
    },
    handleClose (type, visible) {
      this[visible] = false
      // 保存并关闭后刷新列表
      if (type) {
        this.onLoad(this.page, this.query)
      }
    },
    async handleExport () {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `事故上报_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    }

  },
};
</script>

<style lang="scss" scoped>
</style>
